import React, { Component } from 'react';
import './DropdownMenu.css';
import vector from './vector.svg';
import vectorDark from './vector-dark.svg';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getDarkMode } from 'selectors/theme';
import Menu from './Menu';

export const DROPDOWN_TYPES = {
  FORM: 'form-dropdown-menu',
  SECTION_SELECTOR: 'section-selector-dropdown-menu',
};

export const CounterItem = (label, counter) => {
  return (
    <React.Fragment>
      {label}
      <span className="menu-item-counter">{counter}</span>
    </React.Fragment>
  );
};

class DropdownMenu extends Component {
  static propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        selectedLabel: PropTypes.oneOfType([
          PropTypes.element,
          PropTypes.string,
        ]),
        child: PropTypes.number,
        show: PropTypes.bool,
        subitems: PropTypes.arrayOf({}),
      })
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onSubitemChange: PropTypes.func,
    renderSelector: PropTypes.func,
  };

  static defaultProps = {
    type: DROPDOWN_TYPES.FORM,
    value: null,
    placeholder: '',
  };

  handleOnChange = (option) => {
    if (this.props.onChange !== undefined) {
      this.props.onChange(option);
    }
  };
  handleOnSubitemChange = (option) => {
    if (this.props.onSubitemChange !== undefined) {
      this.props.onSubitemChange(option);
    }
  };

  handleRenderSelector = (open) => {
    const {
      options,
      value,
      placeholder,
      renderSelector,
      darkMode,
    } = this.props;

    const selectedOption =
      value !== null && options.find((option) => option.value === value);

    if (renderSelector) {
      return renderSelector(selectedOption, open);
    }

    const label = selectedOption
      ? selectedOption.selectedLabel || selectedOption.label
      : placeholder;
    return (
      <div className="dropdown-menu-selector">
        {label}
        <img
          className="dropdown-menu-selector-arrow"
          src={darkMode ? vectorDark : vector}
          alt="arrow"
        />
      </div>
    );
  };

  render() {
    const { type, className, options, value } = this.props;

    const items = options
      .filter((option) => option.show !== false)
      .map((option) => ({
        className: `${option.className || ''} ${
          option.value === value ? 'selected' : ''
        }`,
        content: option.label,
        child: option.child,
        onClick: () => this.handleOnChange(option),
        closeOnSelect: option.closeOnSelect,
        isDate: option.isDate,
        onDateChange: option.onDateChange,
        dateValue: option.dateValue,
        subitems:
          option.subitems &&
          option.subitems.map((si) => ({
            className: `${si.className || ''} ${
              si.value === value ? 'selected' : ''
            }`,
            content: si.label,
            child: si.child,
            onClick: () => this.handleOnChange(si),
            onChange: () => this.handleOnChange(si),
            closeOnSelect: si.closeOnSelect,
            isDate: si.isDate,
            onDateChange: si.onDateChange,
            dateValue: si.dateValue,
          })),
      }));

    return (
      <Menu
        className={`dropdown-menu-container ${type} ${className || ''}`}
        renderSelector={this.handleRenderSelector}
        items={items}
        placement="bottom-start"
      />
    );
  }
}

export default connect((state) => {
  return {
    darkMode: getDarkMode(state),
  };
})(DropdownMenu);
